import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApChargeBackTopBarComponent } from './ap-charge-back-top-bar.component';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { RlHistoryBackLinkModule } from 'src/app/directives/rl-history-back-link/rl-history-back-link.module';
import { VoidRecordModule } from 'src/app/widgets/records/void-record/void-record.module';
import { RouterModule } from '@angular/router';
import { ProcessingDialogModule } from 'src/app/widgets/processing-dialog/processing-dialog.module';
import { ConfirmationModule } from 'src/app/widgets/confirmation/confirmation.module';


@NgModule({
  declarations: [ApChargeBackTopBarComponent],
  exports: [ApChargeBackTopBarComponent],
  imports: [
    CommonModule,
    ConfirmationModule,
    MatButtonModule,
    MatMenuModule,
    ProcessingDialogModule,
    RlHistoryBackLinkModule,
    RouterModule,
    VoidRecordModule
  ]
})
export class ApChargeBackTopBarModule { }
